'use client';

import { Button } from '@eliadmin/core/src/components/ui/button';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useResponsiveDialogStore } from '@eliadmin/core/src/components/ui/responsive-dialog';
import { useEffect, useRef, useState } from 'react';

export const AskForProductButton = ({ name }: { name: string }) => {
  const { t } = useTranslations();
  const open = useResponsiveDialogStore(state => state.open);
  const pending = useRef(false);
  const mounted = useRef(true);
  const [isLoading, setIsLoading] = useState(false);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);

  async function handleOpen() {
    if (pending.current) return;
    pending.current = true;
    setIsLoading(true);
    setFailed(false);
    try {
      // Keep the inquiry form, validation, country picker and HTML runtime out
      // of the product's initial graph. First click is replayed exactly once.
      const { ProductAskDialog } = await import('./product-ask-dialog');
      if (mounted.current) open({ id: ProductAskDialog.id, content: <ProductAskDialog /> });
    } catch {
      // A failed chunk request must leave an enabled, retryable button.
      if (mounted.current) setFailed(true);
    } finally {
      pending.current = false;
      if (mounted.current) setIsLoading(false);
    }
  }

  return (
    <>
      <Button
        type="button"
        onClick={handleOpen}
        disabled={isLoading}
        aria-busy={isLoading}
        className={cn(
          'flex-grow sm:w-fit sm:flex-grow-0',
          'ea-product-detail-actions__ask-for-product-button',
        )}
      >
        {t('text1361')}
      </Button>
      {failed && (
        <span role="alert" className="text-sm">
          {t('text660')}
        </span>
      )}
    </>
  );
};
